"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _scales = _interopRequireDefault(require("../foundational-styles/scales"));

var spinnerColor = _scales.default.neutral.N6A;
var _default = spinnerColor;
exports.default = _default;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uLy4uL3NyYy90aGVtZS9zcmMvZGVmYXVsdC10aGVtZS9jb21wb25lbnQtc3BlY2lmaWMvc3Bpbm5lckNvbG9yLmpzIl0sIm5hbWVzIjpbInNwaW5uZXJDb2xvciIsInNjYWxlcyIsIm5ldXRyYWwiLCJONkEiXSwibWFwcGluZ3MiOiI7Ozs7Ozs7OztBQUFBOztBQUVBLElBQU1BLFlBQVksR0FBR0MsZ0JBQU9DLE9BQVAsQ0FBZUMsR0FBcEM7ZUFFZUgsWSIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCBzY2FsZXMgZnJvbSAnLi4vZm91bmRhdGlvbmFsLXN0eWxlcy9zY2FsZXMnXG5cbmNvbnN0IHNwaW5uZXJDb2xvciA9IHNjYWxlcy5uZXV0cmFsLk42QVxuXG5leHBvcnQgZGVmYXVsdCBzcGlubmVyQ29sb3JcbiJdfQ==


//////////////////
// WEBPACK FOOTER
// ./~/evergreen-ui/commonjs/theme/src/default-theme/component-specific/spinnerColor.js
// module id = 240
// module chunks = 0